<template>
    <div class="module__add">
        <div class="module__add_header">
            <view-actions
                :breadcrumb-active="true"
                :breadcrumb-items="[
                    {
                        name: 'Modules',
                        to: { name: 'ebs-module-list' }
                    }
                ]"
                :cancel-button-text="'Cancel'"
                :cancel-notify-active="true"
                :cancel-notify-content-text="'This action will remove all changes. Continue?'"
                :cancel-notify-submit-text="'Discard draft'"
                :custom-button-active="allowPerformSubmitModule"
                :custom-button-text="'Save draft'"
                :custom-button-animate-loading="true"
                :custom-button-animate-loading-event-name="'module-save'"
                :notify-title="'module'"
                :notify-process="'stop adding'"
                :submit-button-active="allowPerformSubmitModule"
                :submit-button-text="'Save & release'"
                :title="'New module'"
                @emit-notify-cancel-submit="moduleStopAdd"
                @emit-submit="openReleaseNotify"
                @emit-custom="performSubmitValidate"
            />
        </div>
        <div class="module__add_main">
            <div class="container fullheight">
                <div class="columns is-block-mobile fullheight m-t-b-0">
                    <div class="column is-narrow p-t-b-0">
                        <component-sidebar :nav-items="[
                            { label: 'Content', name: 'ebs-module-add-content', visible: () => true },
                            { label: 'Details', name: 'ebs-module-add-details', visible: () => moduleContent },
                            { label: 'Versions', name: 'ebs-module-add-versions', visible: () => false }
                        ]"></component-sidebar>
                    </div>
                    <div class="column p-t-b-0">
                        <section class="module__add_main_content">
                            <keep-alive>
                                <transition name="fade" mode="out-in">
                                    <router-view/>
                                </transition>
                            </keep-alive>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
        <pop-notify
            ref="popnotifyrelease"
            :cancel-button-text="'Cancel'"
            :class="'pop__notify--release'"
            :content-text="'Release generates new public version from recently saved draft. Changes are automatically delivered to all customers.'"
            :form-active="true"
            :form-fields="[
                {
                    type: 'editor',
                    label: 'Release notes',
                    subLabel: 'Release notes can be seen by administrators on all version updates.',
                    answers: moduleReleaseNotes,
                    validation: { mandatory: true }
                }
            ]"
            :prevent-close="true"
            :size="'medium'"
            :submit-button-text="'Release'"
            :submit-button-animate-loading="true"
            :submit-button-animate-loading-name="'module-save'"
            :title-text="'Release module'"
            @emit-form="setModuleReleaseNotes"
            @emit-submit="performSubmitValidate({ payload: { moduleId: moduleId, release: true } })"
        />
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import PopNotify from '@/components/default/shared/PopNotify'
import { validateBeforeRouteLeave, performSubmitValidate } from '@/helpers/mixins'
import ComponentSidebar from '@/components/default/shared/ComponentSidebar'

export default {
  components: {
    ComponentSidebar,
    PopNotify,
    ViewActions
  },
  name: 'module-add',
  mixins: [validateBeforeRouteLeave, performSubmitValidate],
  computed: {
    moduleId () {
      return this.$store.getters.getEbsModuleId
    },
    moduleName () {
      return this.$store.getters.getEbsModuleName
    },
    moduleDescription () {
      return this.$store.getters.getEbsModuleDescription
    },
    moduleFile () {
      return this.$store.getters.getEbsModuleContent
    },
    moduleDefaultName () {
      return this.$store.getters.getEbsModuleDefaultName
    },
    moduleReleaseNotes () {
      return this.$store.getters.getEbsModuleReleaseNotes
    },
    //
    rootItemName () {
      return 'module'
    },
    nameActionCreate () {
      return 'ebsModuleCreateSCORM'
    },
    nameActionUpdate () {
      return 'ebsModuleUpdateSCORM'
    },
    paramsActionUpdate () {
      return { moduleId: this.moduleId }
    },
    //
    allowPerformSubmitModule () {
      return Boolean(this.moduleName) && Boolean(this.moduleDescription) && Boolean(this.moduleFile)
    },
    moduleContent () {
      return this.$store.getters.getEbsModuleContent
    }
  },
  methods: {
    openReleaseNotify () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$refs.popnotifyrelease.openNotify()
        } else {
          this.$refs.popnotifyvalidation.openNotify()
        }
      })
    },
    performSubmitValidateValidationCallback () {
      this.$eventBus.$emit('stop-module-save')
    },
    performSubmitValidateFinallyCallback () {
      this.$eventBus.$emit('stop-module-save')
    },
    performSubmitValidateThenCallback () {
      if (this.$refs.popnotifyrelease) {
        this.$refs.popnotifyrelease.closeNotify()
      }
    },
    allowRedirectBeforeRouteLeave () {
      this.$eventBus.$emit('module-submit')
    },
    //
    moduleStopAdd () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'ebs-module-list' })
    },
    setModuleReleaseNotes (data) {
      this.$store.dispatch('ebsModuleSetReleaseNotes', data.value)
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/modules/moduleaddedit";
</style>
